export const AppRoutes = {
  COURSES: "/",
  NEW_COURSE: "/courses/new",
  COURSE: "/courses/", // + id
  SECTIONS: "/sections",
  NEW_SECTION: "/sections/new",
  SECTION: "/sections/", // + id
  LESSONS: "/lessons",
  NEW_LESSON: "/lessons/new",
  LESSON: "/lessons/", // + id
  DOMAIN_TAG_NEW: "/domain-tag/new",
  DOMAIN_TAG: "/domain-tag/", // + id
  TASKS: "/tasks", // + id
  USERS: "/users",
  USER: "/users/", // + id
  NEW_USER: "/users/new",
  PAYMENTS: "/payments",
  COUPONS: "/coupons",
  COUPON: "/coupons/", // + id
  NEW_COUPON: "/coupons/new",
  WORDS: "/words",
  WORD: "/words/", // + id
  NEW_WORD: "/words/new",
  REWARDS: "/rewards",
  REWARD: "/rewards/", // + id
  NEW_REWARD: "/rewards/new",
  KOALA_PHRASES: "/koala-phrases",
  KOALA_PHRASE: "/koala-phrases/", // + id
  NOTIFICATIONS: "/notifications",
  NOTIFICATION: "/notifications/", // + id
  NEW_NOTIFICATION: "/notifications/new",
  LOGIN: "/login",
  NOT_FOUND: "/404",
} as const;

export type AppRoutesType = typeof AppRoutes;

export const getCoursesPage = () => "/";
export const getNewCourse = () => "/courses/new";
export const getCourseItem = (id: string) => `/courses/${id}`;
export const getSections = (id: string) => `/courses/${id}/sections`;
export const getNewSection = (id: string) => `/courses/${id}/sections/new`;
export const getSectionItem = (courseId: string, sectionId: string) =>
  `/courses/${courseId}/sections/${sectionId}`;
export const getLessons = (courseId: string, sectionId: string) =>
  `/courses/${courseId}/sections/${sectionId}/lessons`;
export const getLessonItem = (
  courseId: string,
  sectionId: string,
  lessonId: string,
) => `/courses/${courseId}/sections/${sectionId}/lessons/${lessonId}`;
export const getNewLesson = (courseId: string, sectionId: string) =>
  `/courses/${courseId}/sections/${sectionId}/lessons/new`;
export const getNewDomainTag = (
  courseId: string,
  sectionId: string,
  lessonId: string,
) =>
  `/courses/${courseId}/sections/${sectionId}/lessons/${lessonId}/domain-tag/new`;
export const getDomainTagItem = (
  courseId: string,
  sectionId: string,
  lessonId: string,
  domainTag: string,
) =>
  `/courses/${courseId}/sections/${sectionId}/lessons/${lessonId}/domain-tag/${domainTag}/tasks`;

export const getUsersPage = () => "/users";
export const getNewUsersPage = () => "/users/new";
export const getUserItemPage = (userId: string) => `/users/${userId}`;

export const getCouponsPage = () => "/coupons";
export const getNewCouponPage = () => `/coupons/new`;
export const getCouponsItemPage = (couponId: string) => `/coupons/${couponId}`;

export const getPaymentsPage = () => "/payments";

export const getWordsPage = () => "/words";
export const getNewWordPage = () => "/words/new";
export const getWordItemPage = (wordId: string) => `/words/${wordId}`;

export const getRewardsPage = () => "/rewards";
export const getNewRewardPage = () => "/rewards/new";
export const getRewardItemPage = (rewardId: string) => `/rewards/${rewardId}`;

export const getKoalaPhrasesPage = () => "/koala-phrases";
export const getKoalaPhraseItemPage = (koalaPhraseId: string) =>
  `/koala-phrases/${koalaPhraseId}`;

export const getNotificationPage = () => "/notifications";
export const getNewNotificationPage = () => "/notifications/new";
export const getNotificationItemPage = (notificationId: string) =>
  `/notifications/${notificationId}`;

export const getNotFoundPage = () => "/404";
